// components/MyModal.jsx
import React, { useState, useEffect, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import * as general from '../../libs/general';
import { formatOrderDateRangeLabel } from '../../libs/lib-date-range-filter';

// Dùng forwardRef để cha có thể gọi hàm từ con
const OrderFilter = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);

  const year = new Date().getFullYear();


  useEffect(() => {
    setShow(true);
  }, [data]);

  const handleModalShow = (e) => {
    var oldForm = general.getSession('userorders');
    window.initializeFilterValue(oldForm);
    const dateFromInput = document.querySelector('input[name="dateFrom"]');
    if (dateFromInput) dateFromInput.value = oldForm.dateFrom ?? '';
    const dateToInput = document.querySelector('input[name="dateTo"]');
    if (dateToInput) dateToInput.value = oldForm.dateTo ?? '';
    updateDateRangeLabel(oldForm.dateFrom, oldForm.dateTo);
  };

  const handleModalClose = (e) => {
    const allOldErrors = document.querySelectorAll('.error-msg');
    for (var i = allOldErrors.length - 1; i >= 0; i--) allOldErrors[i].remove();
    document.activeElement.blur();
    setShow(false);
  };

  const handleSearchClick = () => {
    if (handleSearch) handleSearch();
    handleModalClose();
  };

  const updateDateRangeLabel = (fromValue, toValue) => {
    const label = formatOrderDateRangeLabel(fromValue, toValue);
    if (window.addFilterValue) window.addFilterValue('dateRange', label);
  };

  const handleDateRangeChange = () => {
    const fromValue = document.querySelector('input[name="dateFrom"]')?.value ?? '';
    const toValue = document.querySelector('input[name="dateTo"]')?.value ?? '';
    updateDateRangeLabel(fromValue, toValue);
  };

  return (
    <Modal show={show} size="lg" onShow={() => handleModalShow()}>
      <div className="modal-dialog11 modal-lg11">
        <div className="modal-content normal-form">
          <div className="modal-header">
            <h5 className="modal-title">Tìm kiếm đơn hàng</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleModalClose}
              aria-label="Đóng"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Ngày</label>
                <div className="th select3">
                  <span className="filter-ib" data-form="form_filter" data-filter="dates" data-source-key="createdDate" data-source-url={API_URL_All + '/api/import-orders/searchDates'} data-default={year}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Line</label>
                <div className="th select3">
                  <span className="filter-ib" data-form="form_filter" data-filter="lines" data-source-key="list_lines"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className="col-md-6 mb-3">
                <label className="form-label">Từ ngày</label>
                <input type="date" className="form-control" name="dateFrom" form="form_filter" onChange={handleDateRangeChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Đến ngày</label>
                <input type="date" className="form-control" name="dateTo" form="form_filter" onChange={handleDateRangeChange} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="th display" style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, overflow: 'hidden' }}>
                  <span className="filter-ib" data-form="form_filter" data-filter="dateRange"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3 th filter-area">
                <label className="form-label">Mã vận đơn TQ</label>
                <textarea placeholder="Nhập mã vận đơn TQ" className="form-control"></textarea>
                <div className=" select3 d-none">
                  <span className="filter-ib" data-form="form_filter" data-filter="chinaCodes" data-source-url={API_URL_All + '/api/import-orders/searchChinaCodes'}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3 th filter-area">
                <label className="form-label">Mã vận đơn VN</label>
                <textarea placeholder="Nhập mã vận đơn VN" className="form-control"></textarea>
                <div className="select3 d-none">
                  <span className="filter-ib" data-form="form_filter" data-filter="vietnamCodes" data-source-url={API_URL_All + '/api/import-orders/searchVietnamCodes'}><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Tên sản phẩm</label>
                <div className="th select3">
                  <span className="filter-ib" data-form="form_filter" data-filter="productNames" data-source-url={API_URL_All + '/api/import-orders/searchProductNames'}><input type="text" placeholder="Nhập tên sản phẩm..." /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Lưu trình</label>
                <div className="th select3">
                  <span className="filter-ib filter-input" data-form="form_filter" data-filter="status" data-source-key="list_status"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Đối soát</label>
                <div className="th select3">                  
                  <span className="filter-ib filter-input" data-form="form_filter" data-filter="rateStatus" data-source-key="list_rateStatus"><input type="text" placeholder="Typing here" /></span>
                </div>
              </div>
              <div className="col-12 th filter-check d-none">
                <span className="filter-ib" data-form="form_filter" data-filter="deletion"><input type="checkbox" /></span>
                <label className="form-check-label">Đã xóa</label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-sm btn btn-primary" onClick={handleSearchClick}>Tìm kiếm</button>
          </div>
        </div>
      </div>

    </Modal>
  );
};

export default OrderFilter;
